import { useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { useLocation, useNavigate } from 'react-router-dom';

import { zodResolver } from '@hookform/resolvers/zod';

import { z } from 'zod';

import { usePostResetPwApi } from '@/api/auth';
import Field from '@/components/common/Field/Field';
import InputText from '@/components/common/Input/InputText/InputText';
import { useModalStore } from '@/store/modalStore';
import { useToastStore } from '@/store/toastStore';

import * as S from './style';

interface RegisterField {
	password: string;
	passwordCheck: string;
}
const ModifyPw = () => {
	const location = useLocation();
	const navigate = useNavigate();
	const member_id = location.state?.member_id;
	const { openToast } = useToastStore();
	const { showModal } = useModalStore();

	useEffect(() => {
		if (!member_id) {
			showModal('잘못된 접근입니다.');
			navigate('/auth/login', { replace: true });
		}
		() => {
			location.state = null;
			return;
		};
	}, [member_id]);

	const userRegisterSchema = z
		.object({
			password: z
				.string()
				.min(1, { message: '6~20자의 영문, 숫자,특수문자만 입력 가능합니다.' })
				.min(6, { message: '6~20자의 영문, 숫자,특수문자만 입력 가능합니다.' })
				.max(20, { message: '6~20자의 영문, 숫자,특수문자만 입력 가능합니다.' })
				.regex(/^[A-Za-z0-9!@#$%^&*()-_+=]+$/, { message: '6~20자의 영문, 숫자,특수문자만 입력 가능합니다.' }),
			passwordCheck: z.string().min(1, { message: '비밀번호가 일치하지 않습니다.' }),
		})
		.refine((data) => data.password === data.passwordCheck, {
			message: '비밀번호가 일치하지 않습니다.',
			path: ['passwordCheck'],
		});

	const {
		register,
		handleSubmit,
		watch,
		formState: { errors },
	} = useForm<RegisterField>({
		resolver: zodResolver(userRegisterSchema),
		defaultValues: {
			password: '',
			passwordCheck: '',
		},
	});
	const { mutateAsync: resetPw } = usePostResetPwApi();
	const onClickButton = async () => {
		const res = await resetPw({
			member_id: member_id,
			member_password: watch('password'),
		});
		if (res.data.success) {
			openToast({
				subContent: '대한화장품학회',
				content: '비밀번호가 변경되었습니다.',
			});
			navigate('/auth/login', { replace: true });
		} else {
			showModal('현재 사용중인 비밀번호와 동일합니다.\n다른 비밀번호로 다시 입력해주세요.');
			return;
		}
	};

	return (
		<main>
			<S.Container onSubmit={handleSubmit(onClickButton)}>
				<div className="title">비밀번호 변경</div>
				<S.FieldBox>
					<Field title="*새 비밀번호" error={errors.password?.message ?? ''}>
						<InputText isError={!!errors.password} {...register('password')} type="password" placeholder="6~20자의 영문, 숫자,특수문자" />
					</Field>
					<Field title="*새 비밀번호 확인" error={errors.passwordCheck?.message ?? ''}>
						<InputText type="password" isError={!!errors.passwordCheck} placeholder="6~20자의 영문, 숫자,특수문자" {...register('passwordCheck')} />
					</Field>
					<S.Button type="submit">변경</S.Button>
				</S.FieldBox>
			</S.Container>
		</main>
	);
};
export default ModifyPw;
